import React, { useEffect, useRef, useState } from 'react';
import Table, { Column, TableHandle } from '../../components/Table';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { fetchAgentInteractions } from '../../redux/slices/agentInteractions/thunk';
import { setInteractionFilterData } from '../../redux/slices/agentInteractions/slice';
import { RootState } from '../../redux/store';
import { Button } from '../../components/Button';

const AgentInteractions = () => {
  const dispatch: any = useDispatch();
  const tableRef = useRef<TableHandle>(null);

  const { interactionList, filterData } = useSelector(
    (state: RootState) => state.agentInteractions
  );
  const [refresh, setRefresh] = useState(false)
  const [loading, setLoading] = useState(false)


  const columns: Column<any>[] = [
    {
      key: "createdAt",
      label: "Date & Time",
      customCell: (row) => (
        <div className='flex text-sm text-subTitleText'>
          {moment(row.createdAt).format("DD MMM YYYY, hh:mm A")}
        </div>
      )
    },
    {
      key: "user",
      label: "User (Clicked By)",
      customCell: (row) => (
        <div className='flex flex-col text-sm'>
          <span className="font-semibold text-headingText">{row?.user?.name || "Unknown"}</span>
          <span className="text-subTitleText">{row?.user?.mobileNumber || "N/A"}</span>
        </div>
      )
    },
    {
      key: "agent",
      label: "Agent (Contacted)",
      customCell: (row) => (
        <div className='flex flex-col text-sm'>
          <span className="font-semibold text-headingText">{row?.agent?.name || "Unknown"}</span>
          <span className="text-subTitleText">{row?.agent?.mobileNumber || "N/A"}</span>
        </div>
      )
    },
    {
      key: "actionType",
      label: "Action Type",
      customCell: (row) => (
        <div className='flex items-center'>
          <span
            className={`px-3 py-1 rounded-full text-xs font-semibold tracking-wide capitalize
              ${row.actionType === "whatsapp"
                ? "bg-green-100 text-green-700 border border-green-200"
                : "bg-blue-100 text-blue-700 border border-blue-200"
              }`}
          >
            {row.actionType}
          </span>
        </div>
      )
    },
  ];

  const getData = async () => {
    try {
      setLoading(true)
      await dispatch(fetchAgentInteractions({
        page: filterData.page,
        limit: filterData.limit,
        search: filterData.search
      }));
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }

    setLoading(false)
  }

  useEffect(() => {
    getData()

  }, [filterData.page, filterData.limit, filterData.search, dispatch, refresh]);

  return (
    <div className="p-4">
      <Table
        ref={tableRef}
        columns={columns}
        data={interactionList}
        tableName="Agent Interactions"
        totalCount={filterData.totalCount}
        currentPage={filterData.page}
        pageSize={filterData.limit}
        loading={loading}
        // Search & Pagination handlers
        onSearchChange={(searchText) => {
          dispatch(setInteractionFilterData({ search: searchText, page: 1 }));
        }}
        onPageChange={(page) => {
          dispatch(setInteractionFilterData({ page: page }));
        }}
        onPageSizeChange={(size: number) => {
          dispatch(setInteractionFilterData({ limit: size, page: 1 }));
        }}
        renderRightToolItems={
          <div className='flex gap-2'>
            <Button
              variant="primary"
              onClick={() => setRefresh(!refresh)}
            >
              Refresh
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default AgentInteractions;